export default __webpack_public_path__ + "static/media/logo-ilhuilcamina.e52f1548.png";